module.exports = __webpack_public_path__ + "img/no-image.6af584af.jpg";